


































































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import { Action, Getter } from 'vuex-class';
import AuthActionTypes from '@/modules/auth/AuthActionTypes';
import ListingService from '@/common/services/ListingService';
import ApplicationActionTypes from '@/modules/application/ApplicationActionTypes';
import DpButton from '@/components/atoms/DpButton/index.vue';
import { PlatformActionTypes } from '@/modules/platform/module';
import CompetitorActionTypes from '@/modules/competitor/CompetitorActionTypes';

@Component({
  name: 'PerformanceWidgetMapListingDetail',
  components: {
    SvgIcon,
    DpButton,
  },
})
export default class PerformanceWidgetMapListingDetail extends Vue {
  @Prop() protected listingDetail!: any;

  @Prop() protected currentListing!: any;

  @Prop() protected noActionButtons!: any;

  @Getter('isAuthenticated', { namespace: 'auth' }) protected isAuthenticated!: boolean;

  @Getter('customCompetitorAirbnbListingIds', { namespace: 'competitor' })
  protected customCompetitorAirbnbListingIds: any;

  @Getter('listings', { namespace: 'dashboard' })
  protected userListings: any;

  @Action(ApplicationActionTypes.PUSH_ROUTE, { namespace: 'application' })
  protected dispatchPushRoute!: any;

  @Action(PlatformActionTypes.CONNECT_AIRBNB_UNVERIFIED, { namespace: 'platform' })
  protected dispatchConnectAirbnbUnverified!: any;

  @Action(CompetitorActionTypes.ADD_TO_COMPETITORS, { namespace: 'competitor' })
  protected dispatchAddToCompetitors!: any;

  protected isAnalyzeListingFreeLoading: boolean = false;

  protected get isCompetitor(): boolean {
    if (!this.customCompetitorAirbnbListingIds) {
      return false;
    }
    return this.customCompetitorAirbnbListingIds.indexOf(this.listingDetail.platformListingId.toString()) !== -1;
  }

  protected get watchedListing(): any {
    if (!this.userListings) {
      return null;
    }
    return this.userListings.find(
      (listing: any) => ['airbnb', 'airbnb-unverified'].indexOf(listing.platformType) !== -1
      && listing.platformListingId === this.listingDetail.platformListingId.toString(),
    );
  }

  protected async toAnalyzeListingFree() {
    const listingUrl = ListingService.getPlatformLink(this.listingDetail);
    if (!listingUrl) {
      return;
    }
    if (this.isAuthenticated) {
      this.isAnalyzeListingFreeLoading = true;
      this.dispatchConnectAirbnbUnverified(listingUrl);
    } else {
      (window as any).location.href = `/app/en/airbnb-unverified-connect/${encodeURIComponent(listingUrl)}`;
    }
  }

  protected onClose() {
    this.$emit('onClose');
  }

  protected openListingOnPlatform = (listingDetail: any) => {
    const link = ListingService.getPlatformLink(listingDetail);
    if (link) {
      window.open(link, '_blank');
    }
  };

  protected addToCompetitors() {
    this.dispatchAddToCompetitors({
      platformListingUuid: this.currentListing.uuid,
      airbnbListingId: this.listingDetail.platformListingId,
    });
  }

  protected goToCompetitors() {
    this.dispatchPushRoute({
      name: 'listing',
      params: {
        id: this.currentListing.uuid,
        tabFirst: 'competitors',
      },
    });
  }

  protected goToPerformanceListing() {
    this.dispatchPushRoute({
      name: 'listing',
      params: {
        id: this.watchedListing.uuid,
        tabFirst: 'performance',
      },
    });
  }
}
